import { TypeSubscriptionRecord } from '@/lib/api/subscriptionManager/types';

export enum SubscriptionSource {
  BABYLIST = 'babylist',
  CHECKOUT = 'checkout',
  GIFTING_ACTIVATION = 'gifting_activation',
  GROUP_GIFTING_MIGRATION = 'group_gifting',
  RECHARGE_MIGRATION = 'recharge',
}

export function isBabylistSubscription(subscription: TypeSubscriptionRecord) {
  return subscription.is_babylist;
}

export function isRechargeMigratedSubscription(
  subscription: TypeSubscriptionRecord,
) {
  const source = _getNormalizedSource(subscription);
  return source.includes(SubscriptionSource.RECHARGE_MIGRATION);
}

export function isPlaygeniusOriginatedSubscription(
  subscription: TypeSubscriptionRecord,
) {
  const source = _getNormalizedSource(subscription);
  return source === SubscriptionSource.CHECKOUT;
}

export function isGiftedSubscription(subscription: TypeSubscriptionRecord) {
  const source = _getNormalizedSource(subscription);
  return source === SubscriptionSource.GIFTING_ACTIVATION;
}

export function isGroupGiftingMigratedSubscription(
  subscription: TypeSubscriptionRecord,
) {
  const source = _getNormalizedSource(subscription);
  return source === SubscriptionSource.GROUP_GIFTING_MIGRATION;
}

function _getNormalizedSource(subscription: TypeSubscriptionRecord) {
  return subscription.subscription_source.toLowerCase();
}
